import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { compose } from '../../node_modules/@styled-system/core/dist/index.esm.js';
import { color } from '../../node_modules/@styled-system/color/dist/index.esm.js';
import { typography } from '../../node_modules/@styled-system/typography/dist/index.esm.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
import { layout } from '../../node_modules/@styled-system/layout/dist/index.esm.js';
var Text = styled.div({
  whiteSpace: "pre-line"
}, compose(color, typography, space, layout));
export { Text };